import _ from 'lodash';
import { axiosInstance } from '../helpers';

const createResponseError = (status, data, statusText) => {
  const message = (data && data.message) || statusText || 'Dashboard request failed';
  const error = new Error(message);
  error.status = status;
  error.error = message;
  error.code = data && data.code;
  error.name = (data && data.name) || error.name;
  return error;
};

const handleResponse = response => {
  if (!response) throw createResponseError(500);

  if (!_.includes([200, 201, 204], response.status)) {
    throw createResponseError(response.status, response.data, response.statusText);
  }

  return response.data;
};

const handleRequestError = error => {
  if (error && error.response) {
    return handleResponse(error.response);
  }
  throw error;
};

const getSummary = () => axiosInstance
  .get('/dashboard/stats')
  .then(handleResponse)
  .catch(handleRequestError);

const getCharts = query => axiosInstance
  .get('/dashboard/charts', { params: query })
  .then(handleResponse)
  .catch(handleRequestError);

export const dashboardService = {
  getSummary,
  getCharts,
};
